import { render, staticRenderFns } from "./ApprovalForceActiveMerchant.vue?vue&type=template&id=5e347159"
import script from "./ApprovalForceActiveMerchant.vue?vue&type=script&lang=js"
export * from "./ApprovalForceActiveMerchant.vue?vue&type=script&lang=js"
import style0 from "./ApprovalForceActiveMerchant.vue?vue&type=style&index=0&id=5e347159&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports